var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.86462 6.42366C2.86462 5.94425 3.22439 5.55561 3.6682 5.55561L6.44345 5.55515C6.99485 5.54005 7.48131 5.16131 7.66894 4.60099C7.67387 4.58626 7.67954 4.56808 7.69988 4.50216L7.81947 4.11455C7.89264 3.87691 7.95639 3.66986 8.04561 3.48479C8.39805 2.75368 9.05012 2.24598 9.80366 2.116C9.99438 2.08309 10.1964 2.08324 10.4283 2.0834H14.0512C14.2831 2.08324 14.485 2.08309 14.6758 2.116C15.4293 2.24598 16.0814 2.75368 16.4338 3.48479C16.5231 3.66986 16.5868 3.87691 16.6599 4.11455L16.7795 4.50216C16.7999 4.56808 16.8056 4.58626 16.8105 4.60099C16.9982 5.16131 17.5811 5.54052 18.1324 5.55561H20.8111C21.2548 5.55561 21.6146 5.94425 21.6146 6.42366C21.6146 6.90307 21.2548 7.29171 20.8111 7.29171H3.6682C3.22439 7.29171 2.86462 6.90307 2.86462 6.42366Z",
    fill: "#A70606"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M12.0905 22.9164H12.9102C15.7305 22.9164 17.1406 22.9164 18.0575 22.0173C18.9744 21.1181 19.0682 19.6432 19.2558 16.6933L19.5261 12.4427C19.6279 10.8422 19.6788 10.0419 19.2188 9.53472C18.7588 9.02759 17.9822 9.02759 16.4286 9.02759H8.57201C7.01853 9.02759 6.24179 9.02759 5.78182 9.53472C5.32187 10.0419 5.37276 10.8422 5.47455 12.4427L5.74488 16.6933C5.93248 19.6432 6.02628 21.1181 6.94315 22.0173C7.86001 22.9164 9.27016 22.9164 12.0905 22.9164Z",
    fill: "#A70606"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.187bae84d5aa8c1972edd98bb1a5ad5f.svg";
export { ForwardRef as ReactComponent };